/**
 * Attestation answers (Review page). NOT persisted — the user must
 * re-confirm on reload, by design.
 */
class AttestStore {
  #listeners = new Set();

  #attestAnswers = Array(9).fill(null);
  #attestDetails = "";

  get attestAnswers() { return this.#attestAnswers; }
  set attestAnswers(v) { this.#attestAnswers = v; this.#notify(); }

  get attestDetails() { return this.#attestDetails; }
  set attestDetails(v) { this.#attestDetails = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#attestAnswers = Array(9).fill(null);
    this.#attestDetails = "";
    this.#notify();
  }
}

const attestStore = new AttestStore();
export default attestStore;
